import { render, staticRenderFns } from "./RoleAutoAssignExplainer.vue?vue&type=template&id=7e01f1ea&scoped=true"
import script from "./RoleAutoAssignExplainer.vue?vue&type=script&lang=ts"
export * from "./RoleAutoAssignExplainer.vue?vue&type=script&lang=ts"
import style0 from "./RoleAutoAssignExplainer.vue?vue&type=style&index=0&id=7e01f1ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e01f1ea",
  null
  
)

export default component.exports